import { useQuery } from '@tanstack/react-query';

import { get } from '../api/ventura/lineItem';
import mapLineItemToForm from '../util/mapLineItemToForm';
import { useConfig } from './useConfig';

function useLineItem(lineItemId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['lineItem', lineItemId],
    queryFn: () => get(apiHost, lineItemId),
    select: mapLineItemToForm,
  });

  return query;
}

export default useLineItem;
